
const columnsEstudiantesUveg = [
    {
        header: "Matrícula",
        accessorKey: "matricula",
        sortable: true,
        center: true,
        compact: true,
        width: "200px",
    },
    {
        header: "Nombre completo",
        accessorKey: "nombre",
        sortable: true,
        center: true,
        compact: true,
        width: "40px",
    },
    {
        header: "Correo institucional",
        accessorKey: "correoInstitucional",
        sortable: true,
        center: true,
        compact: true,
        width: "360px",
    },
   
];

export default columnsEstudiantesUveg;
